<template>
    <div class="grid grid-cols-1 p-8 border border-slate-100 bg-slate-50 rounded-md mb-5">
      <div style="min-width:150px" class="py-1 w-1/2 2xl:w-1/4 3xl:w-1/3 mb-4 mx-auto">
        <img @click="$emit('retryQr')" alt="Código QR" :src="qrLink" /> 
      </div>
      <div class="px-5 2xl:w-3/4 3xl:w-2/3">
        <p class="font-bold text-sm mb-4" style="color:black;">{{ $t('INBOX_MGMT.ADD.WHATAPPWEB.QR_STEPS.TITLE') }}</p>
        <div class="text-xs" style="color:black;">
          <ol class="list-decimal list-inside">
            <li>
              {{ $t('INBOX_MGMT.ADD.WHATAPPWEB.QR_STEPS.ANDROID.FIRST_STEP_BEFORE_ICON') }}
              <fluent-icon
                class="bg-white border border-slate-100 text-slate-100 rounded-md inline"
                icon="more-vertical"
              />
              {{ $t('INBOX_MGMT.ADD.WHATAPPWEB.QR_STEPS.ANDROID.FIRST_STEP_AFTER_ICON') }}
            </li>
            <li>{{ $t('INBOX_MGMT.ADD.WHATAPPWEB.QR_STEPS.ANDROID.SECOND') }}</li>
          </ol>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      qrLink: {
        type: String,
        required: true
      },
    },
  };
  </script>
  
  <style scoped lang="scss">
  @tailwind base;
  @tailwind components;
  @tailwind utilities;
  </style>
